import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import * as Yup from "yup";
import { DocumentFormTypes, UtilFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { ObjectSchema } from "models/utilTypes/yupSchemaTypes";

function useCreateFormHelper() {
  const [financialYears, setFinancialYears] = useState<AutocompleteListItem[]>([]);

  const storeFinancialYears = useSelector((store: AppState) => store.auth.selectedCompany.financialYears);

  useEffect(() => {
    const now = new Date();

    setFinancialYears(
      storeFinancialYears
        ?.filter((f) => new Date(f.start) < now)
        .map((f): AutocompleteListItem => ({ id: f.id, value: DateHelper.formatDateRange(f.start, f.end), data: f }))
        .sort((a, b) => new Date(b.data.start).getTime() - new Date(a.data.start).getTime()) ?? []
    );
  }, [storeFinancialYears]);

  const validationSchema = Yup.object<DocumentFormTypes.ExportSIE>().shape(
    {
      financialYearId: Yup.number(),
      financialYear: Yup.string().when("dateRange", ([dateRange], schema: Yup.StringSchema) =>
        !dateRange
          ? schema.required(
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.OneOfRequired, undefined, {
                itemRequired: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.FinancialYear2),
                itemNotProvided: LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Common.DateRange
                ).toLowerCase(),
              })
            )
          : schema
      ),
      dateRange: Yup.object<UtilFormTypes.DateRange>({
        start: Yup.date(),
        end: Yup.date(),
      }).when("financialYear", ([financialYear], schema: ObjectSchema<UtilFormTypes.DateRange>) =>
        !financialYear
          ? schema.shape({
              start: Yup.date().required(
                LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.OneOfRequired, undefined, {
                  itemRequired: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StartDate),
                  itemNotProvided: LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.Accounting.FinancialYear2
                  ).toLowerCase(),
                })
              ),
              end: Yup.date().required(
                LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.OneOfRequired, undefined, {
                  itemRequired: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EndDate),
                  itemNotProvided: LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.Accounting.FinancialYear2
                  ).toLowerCase(),
                })
              ),
            })
          : schema
      ),
    },
    [["financialYear", "dateRange"]]
  );

  return { financialYears, validationSchema };
}

export default useCreateFormHelper;
